import { SET_EDUCATION,GET_EDUCATION,CREATE_EDUCATION, UPDATE_EDUCATION, DELETE_EDUCATION } from '../actions/actionTypes';

const initialState = {
  educardItemData:[],edutotalCount:0,educardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).startDate;

  console.log('date1',date1);

  return date1;
}


export default function educations(state = initialState, action) {

  switch (action.type) {
     case GET_EDUCATION:
      
      return{
       ...state,
        educardData: action.getCardData,
        edutotalCount:action.totalCount,
        educardItemData:action.cardItemData,
        cardItemDataShow:action.cardItemDataShow

      };
      case CREATE_EDUCATION:

      console.log("Action in add education", action)

      if(!action.newlyAddedEducation) {
        //education addition failed for some reason, just return back previous state
        return {
          ...state
        }
      }

      let updatedEducations = state.educardItemData
      updatedEducations.push(action.newlyAddedEducation)

      let totalCount=0;
      let finaldata=[];
      let setCardItemDataShow=false; 


      totalCount = updatedEducations.length

      let getCardItemData = updatedEducations.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

      if(totalCount > 3) {
        setCardItemDataShow = true
      }

      if(getCardItemData.length > 0) {
        for (let i = 0; i < getCardItemData.length; i++) {
          const data = getCardItemData[i].newdata;
          let datecheck = checkdate(data);

          getCardItemData[i]['datecheck'] = datecheck;

          //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed

          ///handling logic
        }
      }

      let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

      finaldata = getCardItemData2

      return{
        ...state,
        opentost:action.opentost,
        tost_msg:action.tost_msg,
        educardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,
        edutotalCount: totalCount,  
        cardItemDataShow: setCardItemDataShow,
        educardData: action.getCardData
      };

      case UPDATE_EDUCATION:
        if(!action.updatedEducationItem) {
          //education was not updated, just return back the previous state
          return {
            ...state
          }
        } 
        const matchingEduItemIndex = state.educardItemData.findIndex(eduItem => eduItem.id === action.updatedEducationItem.id)

        if(matchingEduItemIndex !== -1) {
          state.educardItemData[matchingEduItemIndex] = action.updatedEducationItem
        }
        
        return {
          ...state
        }
       
      case DELETE_EDUCATION:
        console.log("Delete education reducer") 
        if(action.deleteSuccess) {
          console.log("Delete was successful")
          const educationsAfterDelete = action.educardItemData
          console.log("educationsAfterDelete", educationsAfterDelete)
  
          let totalCountAfterDelete=0;
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;
          
          
          totalCountAfterDelete = educationsAfterDelete.length
  
          let cardItemsData = educationsAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  
  
          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }
  
          if(cardItemsData.length > 0) {
            for (let i = 0; i < cardItemsData.length; i++) {
              const data = cardItemsData[i].newdata;
              let datecheck = checkdate(data);
    
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }
  
          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))
  
          finaldataAfterDelete = cardItemsData2
  
          return{
            ...state,
            educardItemData: finaldataAfterDelete,
            edutotalCount: totalCountAfterDelete,  
            cardItemDataShow: setCardItemDataShowAfterDelete,
          };
        } else {
          //delete was not successful, just return state with toast details
          //Note:- UI does not show error for failure, need to implement this
          console.log("Delete was not successfull")
          return {
            ...state
          }
        }

        
        

    default: return state;
  }
};

